import { paymentProvider } from "@@/shared/payments/payment-providers";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { signatureFactory } from "../../signature-factory";
import type {
    _OrderEventBaseFactoryParams} from "../_order-base.event";
import {
    _orderEventBaseFactory,
    _orderEventBaseZodObject,
} from "../_order-base.event";
import { orderEventIdZodSchema } from "../_order-event-id";

//Amount has been paid by external channel payment provider

const _eventPaymentProviders = [paymentProvider.STRIPE] as const;
const orderEventPaymentAmountPrepaidZodObject = _orderEventBaseZodObject.merge(
    z.object({
        type: z.literal("PAYMENT_AMOUNT_PREPAID"),
        createdBy: userIdZodSchema.or(z.string()),
        amount: z.number().min(0),
        paymentFor: z.object({
            orderEventId: orderEventIdZodSchema,
        }),
    }),
);
type OrderPaymentAmountPrepaidEvent = z.infer<
    typeof orderEventPaymentAmountPrepaidZodObject
>;
const orderEventPaymentAmountPrepaidZodSchema =
    orderEventPaymentAmountPrepaidZodObject as z.ZodSchema<OrderPaymentAmountPrepaidEvent>;

type FactoryParams = _OrderEventBaseFactoryParams &
    Except<
        OrderPaymentAmountPrepaidEvent,
        "type" | "_id" | "_type" | "_createdAt" | "signature"
    >;
type Params = Except<FactoryParams, "signature">;

const orderEventPaymentAmountPrepaidFactory = (
    params: Params,
): OrderPaymentAmountPrepaidEvent => ({
    ..._orderEventBaseFactory({
        ...params,
        signature: signatureFactory(params.orderId, "PAYMENT_AMOUNT_PREPAID", [
            params.paymentFor.orderEventId,
        ]),
    }),

    type: "PAYMENT_AMOUNT_PREPAID",
    createdBy: params.createdBy,
    amount: params.amount,
    paymentFor: params.paymentFor,
});

const isOrderPaymentAmountPrepaidEvent = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any,
): item is OrderPaymentAmountPrepaidEvent => {
    return item.type === "PAYMENT_AMOUNT_PREPAID";
};

export {
    isOrderPaymentAmountPrepaidEvent,
    orderEventPaymentAmountPrepaidFactory,
    orderEventPaymentAmountPrepaidZodObject,
    orderEventPaymentAmountPrepaidZodSchema,
};
export type { OrderPaymentAmountPrepaidEvent };
